import { useProviderWorkspace } from "../ProviderWorkspaceContext";
import { SettingsCard } from "../SettingsCard";
import { ProviderTeamCard } from "../../provider-team/ProviderTeamCard";
import { useState } from "react";

export function BusinessSection() {
  const { venues, t } = useProviderWorkspace();
  const [activeTab, setActiveTab] = useState<"settings" | "team">("settings");

  return (
    <div className="grid gap-4">
      <header className="min-w-0">
        <p className="ops-kicker">{t("Setup")}</p>
        <h1 className="ops-page-title">{t("Business & team")}</h1>
        <p className="ops-copy mt-1 text-sm">{t("How you take payment and print receipts, your business details, and who can use this workspace.")}</p>
      </header>
      <div className="flex flex-wrap items-center gap-2" role="tablist" aria-label={t("Business tabs")}>
        <button
          className="ops-button"
          data-size="sm"
          data-variant={activeTab === "settings" ? "primary" : "secondary"}
          onClick={() => setActiveTab("settings")}
          type="button"
          role="tab"
          aria-selected={activeTab === "settings"}
        >
          {t("Settings")}
        </button>
        <button
          className="ops-button"
          data-size="sm"
          data-variant={activeTab === "team" ? "primary" : "secondary"}
          onClick={() => setActiveTab("team")}
          type="button"
          role="tab"
          aria-selected={activeTab === "team"}
        >
          {t("Team")}
        </button>
      </div>
      {activeTab === "settings" ? <SettingsCard /> : <ProviderTeamCard venues={venues} />}
    </div>
  );
}
